/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    no-unreachable
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import classNames from 'classnames';
import reactUpdate from 'immutability-helper';
import moment from 'moment';
import React from 'react';
import _ from 'underscore';

import {getPurposesForFolderSection} from 'archive/ArchivePurposesUtil';
import {assert} from 'Asserts';
import {AssaysFeature, RecipesFeature, RegistryFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {MolbioFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import * as ExportConstants from 'constants/ExportConstants';
import {FolderSection} from 'constants/FolderConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {getRegistrySupportedOligoAwareTypes, Registry} from 'constants/RegistryConstants';
import MultipleFolderSelector from 'file-browser/MultipleFolderSelector';
import notifications from 'notifications';
import isBatchesEnabled from 'registry/IsBatchesEnabled';
import RegistrySelector from 'registry/RegistrySelector';
import * as RegistryUtil from 'registry/RegistryUtil';
import TagSchemaSelector from 'schemas/shared/TagSchemaSelector';
import ArchivePurposesFilterForm from 'search/filters/ArchivePurposesFilterForm';
import {FilterStyle} from 'search/filters/base/FilterFormConstants';
import {FilterKey, Operator} from 'search/SearchConstants';
import EntityStore from 'stores/EntityStore';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {FolderItemIcon} from 'ui-library/icons/IconConstants';
import DateField from 'ui-library/inputs/DateField';
import {MOMENT_DATE_FORMAT} from 'ui-library/inputs/LegacyDateInput';
import * as LoadingScreen from 'ui-library/LoadingScreen';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';

import ExportActions from './ExportActions';

const REGISTRY_ITEM_TYPE_FILE = 'file';
const REGISTRY_ITEM_TYPE_BATCH = 'batch';

function _dateToMoment(date: any): moment.Moment {
  return moment(date, 'YYYY-MM-DD', true);
}

interface ExportOption {
  type: string;
  name: string;
  description: string;
  icon: BenchlingIconName;
}

interface Props {
  exportType: string;
  folderIds: Array<string>;
  onRequestClose: (...args: Array<any>) => any;
  registry?: Registry;
}

type State = any;

class ExportModal extends React.Component<Props, State> {
  static open(props?: any): void {
    if (EntityStore.currentUser() == null) {
      notifications.warn('Please sign in to export the folder.');
      return;
    }
    ModalContainer.open(
      ExportModal,
      <ExportModal
        {...props}
        onRequestClose={function () {
          ExportModal.close();
        }}
      />
    );
  }

  static openForFolder(folder: any): void {
    if (RegistryUtil.isRegistryFolder(folder)) {
      ExportModal.open({
        exportType: ExportConstants.TYPE.REGISTRY,
        registry: folder.source,
      });
    } else {
      ExportModal.open({folderIds: [folder.id]});
    }
  }

  static close(): void {
    ModalContainer.close(ExportModal);
  }

  static defaultProps = {
    exportType: ExportConstants.TYPE.ALL,
    folderIds: [],
  };

  state: State = {
    folderIds: this.props.folderIds,
    exportType: this.props.exportType,
    exportTypeToConfig: _.object([
      [
        ExportConstants.TYPE.ALL,
        {
          fileFormat: ExportConstants.FILE_FORMAT.HTML,
          // eslint-disable-next-line no-restricted-syntax
          archivePurposes: _.uniq([
            ...BenchlingConfig.ARCHIVE_EXPENDABLE_PURPOSES,
            ...BenchlingConfig.ARCHIVE_NON_EXPENDABLE_PURPOSES,
          ]),
        },
      ],
      [
        ExportConstants.TYPE.REGISTRY,
        {
          fileFormat: ExportConstants.FILE_FORMAT.CSV,
          folderSection: FolderSection.INVENTORY,
          archivePurposes: BenchlingConfig.ARCHIVE_EXPENDABLE_PURPOSES,
        },
      ],
      [
        ExportConstants.TYPE.ENTRIES,
        {
          grouping: ExportConstants.GROUPING_FORMAT.BY_ENTRY,
          fileFormat: ExportConstants.FILE_FORMAT.HTML,
          folderSection: FolderSection.NOTEBOOK,
          archivePurposes: BenchlingConfig.ARCHIVE_NON_EXPENDABLE_PURPOSES,
        },
      ],
      [
        ExportConstants.TYPE.SEQUENCE,
        {
          fileFormat: ExportConstants.FILE_FORMAT.ZIP,
          folderSection: FolderSection.INVENTORY,
          archivePurposes: BenchlingConfig.ARCHIVE_EXPENDABLE_PURPOSES,
        },
      ],
      [
        ExportConstants.TYPE.OLIGO,
        {
          fileFormat: ExportConstants.FILE_FORMAT.CSV,
          folderSection: FolderSection.INVENTORY,
          archivePurposes: BenchlingConfig.ARCHIVE_EXPENDABLE_PURPOSES,
        },
      ],
      [
        ExportConstants.TYPE.WORKSHEET,
        {
          fileFormat: ExportConstants.FILE_FORMAT.PDF,
          folderSection: FolderSection.NOTEBOOK,
          archivePurposes: [],
        },
      ],
    ]),
    entriesDisplayStartDate: '',
    entriesDisplayEndDate: '',
    allFolders: null,
    loading: false,
    registry: this.props.registry,
    registryItemType: null,
    tagSchemaId: null,
  };

  getValidOptions = (): Array<ExportOption> => {
    let options: Array<ExportOption> = [
      {
        type: ExportConstants.TYPE.ALL,
        name: 'All Items',
        description: 'ZIP Archive',
        icon: ModelTypeConstants.FOLDER,
      },
    ];

    if (isFeatureEnabled({feature: RegistryFeature.REGISTRY_EXPORT})) {
      options = [
        ...options,
        {
          type: ExportConstants.TYPE.REGISTRY,
          name: 'Registered Entities',
          description: 'Spreadsheet',
          icon: ModelTypeConstants.REGISTRY,
        },
      ];
    }

    options = [
      ...options,
      {
        type: ExportConstants.TYPE.ENTRIES,
        name: 'Entries',
        description: 'PDF or HTML',
        icon: FolderItemIcon.Entry,
      },
    ];

    if (isFeatureEnabled({feature: MolbioFeature.MOLBIO_EXPORT})) {
      options = [
        ...options,
        {
          type: ExportConstants.TYPE.SEQUENCE,
          name: 'Sequences',
          description: 'GenBank/GenPept',
          icon: FolderItemIcon.Sequence,
        },
        {
          type: ExportConstants.TYPE.OLIGO,
          name: 'Oligos',
          description: 'Spreadsheet',
          icon: ModelTypeConstants.SEQUENCE_PRIMER,
        },
      ];
    }

    if (
      isFeatureEnabled({feature: RecipesFeature.RECIPES_EXPORT}) ||
      isFeatureEnabled({feature: AssaysFeature.ASSAYS_EXPORT})
    ) {
      options = [
        ...options,
        {
          type: ExportConstants.TYPE.WORKSHEET,
          name: 'Worksheets',
          description: 'PDF Only',
          icon: ModelTypeConstants.WORKSHEET,
        },
      ];
    }

    options.forEach((exportOption) => {
      // eslint-disable-next-line benchlint/no-in-operator
      assert(exportOption.type in ExportConstants.TYPE, 'unrecognized export option type');
    });

    return options;
  };

  updateSelectedFolders = (folders: any): void => {
    this.setState({
      // TODO(T2222): Change this to `folder.id` once folderResp ID is API ID.
      folderIds: folders.map((folder: any) => folder.api_identifier),
    });
  };

  handleSelectorLoadAllFolders = (allFolders: any): void => {
    this.setState({allFolders});
  };

  handleRegistryChange = (e: any): void => {
    const registry = e.target.value;
    const newState: {registry: any; tagSchemaId?: null} = {registry};
    if (registry !== this.state.registry) {
      // If the registry changed, the old tag schema will no longer be valid since it won't belong
      // to the new registry
      newState.tagSchemaId = null;
    }
    this.setState(newState);
  };

  handleTagSchemaChange = (tagSchema: any): void => {
    assert(tagSchema != null, 'TagSchemaSelector returned a null tag schema');
    this.setState({tagSchemaId: tagSchema.id});
  };

  handleItemTypeChange = (type: any): void => {
    this.setState({registryItemType: type});
  };

  setExportType = (exportType: any): void => {
    this.setState({exportType});
  };

  _setConfig = (exportType: string, newState: any): void => {
    const newConfig = reactUpdate(this.state.exportTypeToConfig[exportType], {
      $merge: newState,
    });
    this.setState({
      exportTypeToConfig: reactUpdate(this.state.exportTypeToConfig, {
        $merge: _.object([[exportType, newConfig]]),
      }),
    });
  };

  setFileFormat = (e: any): void => {
    this._setConfig(this.state.exportType, {fileFormat: e.target.value});
  };

  setArchivePurposes = (e: any): void => {
    this._setConfig(this.state.exportType, {
      archivePurposes: e.value,
    });
  };

  setGroupingFormat = (e: any): void => {
    assert(
      this.state.exportType === ExportConstants.TYPE.ENTRIES,
      `Export type does not support grouping formats: ${this.state.exportType}`
    );
    this._setConfig(ExportConstants.TYPE.ENTRIES, {grouping: e.target.value});
  };

  // This maps format options to Export FORMAT that match the backend.
  _getSelectedExportFormat = (exportType: any): string | undefined => {
    const {fileFormat, grouping} = this.state.exportTypeToConfig[exportType];
    switch (exportType) {
      case ExportConstants.TYPE.ALL:
        if (fileFormat === ExportConstants.FILE_FORMAT.ZIP) {
          return ExportConstants.FORMAT.ALL_ZIP;
        } else if (fileFormat === ExportConstants.FILE_FORMAT.HTML) {
          return ExportConstants.FORMAT.ALL_ZIP_HTML;
        }
        return undefined;
        break;

      case ExportConstants.TYPE.REGISTRY:
        assert(
          fileFormat === ExportConstants.FILE_FORMAT.CSV,
          `Invalid file format for Registry export: ${exportType}`
        );
        return ExportConstants.FORMAT.REGISTRY_CSV;
        break;

      case ExportConstants.TYPE.ENTRIES:
        if (fileFormat === ExportConstants.FILE_FORMAT.PDF) {
          if (grouping === ExportConstants.GROUPING_FORMAT.BY_DATE) {
            return ExportConstants.FORMAT.ENTRIES_GROUP_BY_DATE;
          } else {
            assert(
              grouping === ExportConstants.GROUPING_FORMAT.BY_ENTRY,
              `Invalid grouping format for Entries export: ${grouping}`
            );
            return ExportConstants.FORMAT.ENTRIES_GROUP_BY_ENTRY;
          }
        } else {
          assert(
            fileFormat === ExportConstants.FILE_FORMAT.HTML,
            `Invalid file format for Entries export: ${exportType}`
          );
          if (grouping === ExportConstants.GROUPING_FORMAT.BY_DATE) {
            return ExportConstants.FORMAT.ENTRIES_GROUP_BY_DATE_HTML;
          } else {
            assert(
              grouping === ExportConstants.GROUPING_FORMAT.BY_ENTRY,
              `Invalid grouping format for Entries export: ${grouping}`
            );
            return ExportConstants.FORMAT.ENTRIES_GROUP_BY_ENTRY_HTML;
          }
        }
        break;

      case ExportConstants.TYPE.SEQUENCE:
        if (fileFormat === ExportConstants.FILE_FORMAT.ZIP) {
          return ExportConstants.FORMAT.SEQUENCE_ZIP;
        } else {
          assert(
            fileFormat === ExportConstants.FILE_FORMAT.MULTIPART_GB,
            `Invalid file format for Sequence export: ${exportType}`
          );
          return ExportConstants.FORMAT.SEQUENCE_MULTIPART_GB;
        }
        break;

      case ExportConstants.TYPE.WORKSHEET:
        if (fileFormat === ExportConstants.FILE_FORMAT.PDF) {
          return ExportConstants.FORMAT.WORKSHEET_PDF;
        } else {
          assert(
            fileFormat === ExportConstants.FILE_FORMAT.PDF,
            `Invalid file format for Worksheet export: ${exportType}`
          );
          return ExportConstants.FORMAT.WORKSHEET_PDF;
        }
        break;

      default:
        assert(exportType === ExportConstants.TYPE.OLIGO, `Invalid export type: ${exportType}.`);
        assert(
          fileFormat === ExportConstants.FILE_FORMAT.CSV,
          `Invalid file format for Oligo export: ${exportType}`
        );
        return ExportConstants.FORMAT.OLIGO_CSV;
    }
  };

  _getArchivePurposes = (exportType: any): Array<string> =>
    this.state.exportTypeToConfig[exportType].archivePurposes;

  getCanSubmit = (): boolean => {
    if (this.state.exportType === ExportConstants.TYPE.REGISTRY) {
      return (
        this.state.registry != null &&
        this.state.tagSchemaId != null &&
        (!isBatchesEnabled() || this.state.registryItemType != null)
      );
    }
    return true;
  };

  submit = (): void => {
    // Validate input and convert to what the server expects.
    let folderIds;

    assert(
      // eslint-disable-next-line no-restricted-syntax
      Array.from(_.values(ExportConstants.TYPE)).includes(this.state.exportType),
      'unexpected export type'
    );
    const selectedFormat = this._getSelectedExportFormat(this.state.exportType);
    assert(
      Array.from(ExportConstants.TYPE_TO_FORMATS[this.state.exportType]).includes(selectedFormat!),
      'unexpected format'
    );
    const archivePurposes = this._getArchivePurposes(this.state.exportType);
    const serverData: {
      format: string | undefined;
      archivePurposes: any;
      startDate?: string;
      endDate?: string;
      tagSchemaId?: any;
      forBatches?: any;
    } = {format: selectedFormat, archivePurposes};
    if (
      this.state.exportType === ExportConstants.TYPE.ENTRIES &&
      (this.state.entriesDisplayStartDate || this.state.entriesDisplayEndDate)
    ) {
      const displayStartMoment = _dateToMoment(this.state.entriesDisplayStartDate);
      const displayEndMoment = _dateToMoment(this.state.entriesDisplayEndDate);
      if (!displayStartMoment.isValid() || !displayEndMoment.isValid()) {
        notifications.error('Start and end dates must both be valid dates or both be unspecified.');
        return;
      }
      // Before: display start and end dates are inclusive.
      // After: start date is inclusive, and end date is exclusive.
      const startMoment = displayStartMoment;
      const endMoment = displayEndMoment.add(1, 'day');
      if (!startMoment.isBefore(endMoment)) {
        notifications.error('Start date must come before end date.');
        return;
      }
      serverData.startDate = startMoment.format(MOMENT_DATE_FORMAT);
      serverData.endDate = endMoment.format(MOMENT_DATE_FORMAT);
    }
    if (this.state.exportType === ExportConstants.TYPE.REGISTRY) {
      folderIds = [this.state.registry.rootFolder.api_identifier];
      serverData.tagSchemaId = this.state.tagSchemaId;
      serverData.forBatches = this.state.registryItemType === REGISTRY_ITEM_TYPE_BATCH;
    } else {
      ({folderIds} = this.state);
    }

    if (_.isEmpty(folderIds)) {
      notifications.error('Please select at least one location.');
      return;
    }
    // Request export.
    ExportActions.requestExportFolders(folderIds, this.state.exportType, serverData);
    this.props.onRequestClose();
  };

  openLoadingScreen = (): void => {
    // TODO(T4346): Temp. block interaction with ExportModal to prevent user from changing to projectOnly
    if (
      !this.state.loading &&
      this.state.allFolders == null &&
      this.state.exportType !== ExportConstants.TYPE.REGISTRY
    ) {
      LoadingScreen.show();
      this.setState({loading: true});
    }
  };

  componentDidMount(): void {
    this.openLoadingScreen();
  }

  componentDidUpdate(prevProps: Props, prevState: State): void {
    this.openLoadingScreen();
    if (
      this.state.loading &&
      (this.state.exportType === ExportConstants.TYPE.REGISTRY ||
        (prevState.allFolders == null && this.state.allFolders != null))
    ) {
      LoadingScreen.hide();
      this.setState({loading: false});
    }
  }

  render(): JSX.Element {
    const selectedConfig = this.state.exportTypeToConfig[this.state.exportType];
    const archivePurposeFilter: {
      key: FilterKey.ARCHIVE_PURPOSES;
      operator: Operator.IS_ONE_OF;
      value: any;
    } = {
      key: FilterKey.ARCHIVE_PURPOSES,
      operator: Operator.IS_ONE_OF,
      value: selectedConfig.archivePurposes,
    };
    const archivePurposeFormProps = {
      buttonSize: ButtonSize.SMALL,
      onChangeOperator: this.setArchivePurposes,
      filter: archivePurposeFilter,
      filterStyle: FilterStyle.PRIMARY,
      onChangeFilter: this.setArchivePurposes,
      onRemove: () => {
        this.setArchivePurposes({});
      },
      hideNotArchivedOption: true,
      hideAllArchivedOption: true,
      archivePurposes: getPurposesForFolderSection(selectedConfig.folderSection),
    };
    return (
      <Modal
        className="exportModal"
        title="Export data"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this.submit}
        buttons={[
          {
            text: 'Export',
            submit: true,
            style: ButtonStyle.PRIMARY,
            disabled: !this.getCanSubmit(),
            dataTestAttrs: {component: 'ExportModal', element: 'exportButton'},
          },
        ]}
        dataTestAttrs={{component: 'ExportModal', element: 'root'}}
        scrollable={false}
        expandHeight={false}
      >
        <div className="exportModal-menu">
          {this.getValidOptions().map((exportOption) => (
            <div
              key={exportOption.type}
              className={classNames({
                'exportModal-option': true,
                'is-selected': this.state.exportType === exportOption.type,
              })}
              onClick={this.setExportType.bind(null, exportOption.type)}
            >
              <h1>
                <BenchlingIcon icon={exportOption.icon} />
              </h1>
              <div>
                <strong>{exportOption.name}</strong>
              </div>
              <div>
                <span>{exportOption.description}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="exportModal-submenu">
          {this.state.exportType === ExportConstants.TYPE.REGISTRY ? (
            <FormGroup>
              <h5>Registry</h5>
              <RegistrySelector
                onChange={this.handleRegistryChange}
                registryId={this.state.registry != null ? this.state.registry.id : undefined}
              />
            </FormGroup>
          ) : (
            <FormGroup>
              <h5>Locations</h5>
              <MultipleFolderSelector
                allFolders={this.state.allFolders}
                includeHiddenProjects={true}
                onLoadAllFolders={this.handleSelectorLoadAllFolders}
                onSelectFolders={this.updateSelectedFolders}
                selectedFolderIds={this.state.folderIds}
                showInventory={[
                  ExportConstants.TYPE.ALL,
                  ExportConstants.TYPE.SEQUENCE,
                  ExportConstants.TYPE.OLIGO,
                ].includes(this.state.exportType)}
                showNotebook={[ExportConstants.TYPE.ALL, ExportConstants.TYPE.ENTRIES].includes(
                  this.state.exportType
                )}
              />
            </FormGroup>
          )}
          {(() => {
            switch (this.state.exportType) {
              case ExportConstants.TYPE.ALL:
                return (
                  <div>
                    <FormGroup>
                      <h5>Format</h5>
                      <Row>
                        <Col sm={6}>
                          <Label className="radio-inline radio-inline--labelAligned">
                            <input
                              type="radio"
                              name="all-format"
                              value={ExportConstants.FILE_FORMAT.HTML}
                              checked={selectedConfig.fileFormat === ExportConstants.FILE_FORMAT.HTML}
                              onChange={this.setFileFormat}
                            />
                            HTML
                          </Label>
                        </Col>
                        <Col sm={6}>
                          <Label className="radio-inline radio-inline--labelAligned">
                            <input
                              type="radio"
                              name="all-format"
                              value={ExportConstants.FILE_FORMAT.ZIP}
                              checked={selectedConfig.fileFormat === ExportConstants.FILE_FORMAT.ZIP}
                              onChange={this.setFileFormat}
                            />
                            PDF
                          </Label>
                        </Col>
                      </Row>
                    </FormGroup>
                  </div>
                );
              case ExportConstants.TYPE.REGISTRY:
                if (this.state.registry != null) {
                  return (
                    <div>
                      <FormGroup>
                        <Row>
                          <Col sm={isBatchesEnabled() ? 6 : 12}>
                            <h5>Schema</h5>
                            <TagSchemaSelector
                              oligoAwareFolderItemTypes={getRegistrySupportedOligoAwareTypes()}
                              onChange={this.handleTagSchemaChange}
                              registryId={this.state.registry != null ? this.state.registry.id : undefined}
                              selectedTagSchemaId={this.state.tagSchemaId}
                            />
                          </Col>
                          {isBatchesEnabled() ? (
                            <Col sm={6}>
                              <h5>Item Type</h5>
                              <Dropdown
                                menu={
                                  <Menu height={Menu.HEIGHTS.MEDIUM} width={Menu.WIDTHS.FULL}>
                                    <Option
                                      onSelect={() => {
                                        this.handleItemTypeChange(REGISTRY_ITEM_TYPE_FILE);
                                      }}
                                    >
                                      Entity
                                    </Option>
                                    <Option
                                      onSelect={() => {
                                        this.handleItemTypeChange(REGISTRY_ITEM_TYPE_BATCH);
                                      }}
                                    >
                                      Batch
                                    </Option>
                                  </Menu>
                                }
                              >
                                <Button
                                  size={ButtonSize.SMALL}
                                  buttonStyle={ButtonStyle.TERTIARY_GRAY}
                                  text={
                                    this.state.registryItemType === REGISTRY_ITEM_TYPE_FILE
                                      ? 'Entity'
                                      : this.state.registryItemType === REGISTRY_ITEM_TYPE_BATCH
                                        ? 'Batch'
                                        : 'Select an Item Type'
                                  }
                                  isDropdown={true}
                                  fullWidth={true}
                                />
                              </Dropdown>
                            </Col>
                          ) : undefined}
                        </Row>
                      </FormGroup>
                    </div>
                  );
                }
                return null;
                break;
              case ExportConstants.TYPE.ENTRIES:
                return (
                  <div>
                    <FormGroup>
                      <h5>Document Type</h5>
                      <Row>
                        <Col sm={6}>
                          <Label className="radio-inline radio-inline--labelAligned">
                            <input
                              type="radio"
                              name="entries-documentType"
                              value={ExportConstants.FILE_FORMAT.HTML}
                              checked={selectedConfig.fileFormat === ExportConstants.FILE_FORMAT.HTML}
                              onChange={this.setFileFormat}
                            />
                            HTML
                          </Label>
                        </Col>
                        <Col sm={6}>
                          <Label className="radio-inline radio-inline--labelAligned">
                            <input
                              type="radio"
                              name="entries-documentType"
                              value={ExportConstants.FILE_FORMAT.PDF}
                              checked={selectedConfig.fileFormat === ExportConstants.FILE_FORMAT.PDF}
                              onChange={this.setFileFormat}
                            />
                            PDF
                          </Label>
                        </Col>
                      </Row>
                    </FormGroup>
                    <FormGroup>
                      <h5>Format</h5>
                      <Row>
                        <Col sm={6}>
                          <Label className="radio-inline radio-inline--labelAligned">
                            <input
                              type="radio"
                              name="entries-format"
                              value={ExportConstants.GROUPING_FORMAT.BY_DATE}
                              checked={selectedConfig.grouping === ExportConstants.GROUPING_FORMAT.BY_DATE}
                              onChange={this.setGroupingFormat}
                            />
                            Grouped by day
                          </Label>
                        </Col>
                        <Col sm={6}>
                          <Label className="radio-inline radio-inline--labelAligned">
                            <input
                              type="radio"
                              name="entries-format"
                              value={ExportConstants.GROUPING_FORMAT.BY_ENTRY}
                              checked={selectedConfig.grouping === ExportConstants.GROUPING_FORMAT.BY_ENTRY}
                              onChange={this.setGroupingFormat}
                            />
                            Grouped by entry
                          </Label>
                        </Col>
                      </Row>
                    </FormGroup>
                    <FormGroup>
                      <h5>
                        {'Date Range '}
                        <small>(optional)</small>
                      </h5>
                      <Row>
                        <Col sm={6}>
                          <DateField
                            labelStyle={DateField.LABEL_STYLES.HIDDEN}
                            placeholder="Start date"
                            value={this.state.entriesDisplayStartDate}
                            onChange={(date: any) => {
                              this.setState({entriesDisplayStartDate: date});
                            }}
                          />
                        </Col>
                        <Col sm={6}>
                          <DateField
                            labelStyle={DateField.LABEL_STYLES.HIDDEN}
                            placeholder="End date"
                            value={this.state.entriesDisplayEndDate}
                            onChange={(date: any) => {
                              this.setState({entriesDisplayEndDate: date});
                            }}
                          />
                        </Col>
                      </Row>
                    </FormGroup>
                  </div>
                );
              case ExportConstants.TYPE.SEQUENCE:
                return (
                  <div>
                    <FormGroup>
                      <h5>Format</h5>
                      <Row>
                        <Col sm={6}>
                          <Label className="radio-inline radio-inline--labelAligned">
                            <input
                              type="radio"
                              name="sequence-format"
                              value={ExportConstants.FILE_FORMAT.ZIP}
                              checked={selectedConfig.fileFormat === ExportConstants.FILE_FORMAT.ZIP}
                              onChange={this.setFileFormat}
                            />
                            ZIP Archive
                          </Label>
                        </Col>
                        <Col sm={6}>
                          <Label className="radio-inline radio-inline--labelAligned">
                            <input
                              type="radio"
                              name="sequence-format"
                              value={ExportConstants.FILE_FORMAT.MULTIPART_GB}
                              checked={selectedConfig.fileFormat === ExportConstants.FILE_FORMAT.MULTIPART_GB}
                              onChange={this.setFileFormat}
                            />
                            Multipart GenBank/GenPept
                          </Label>
                        </Col>
                      </Row>
                    </FormGroup>
                  </div>
                );
              default:
                return null;
            }
          })()}
          {this.state.exportType !== ExportConstants.TYPE.WORKSHEET && (
            <FormGroup>
              <h5>Archive reasons to include</h5>
              {/* Note: ArchivePurposesFilterForm is intended for search filters, so we may want to use a different
                component here. */}
              <ArchivePurposesFilterForm {...archivePurposeFormProps} />
            </FormGroup>
          )}
        </div>
      </Modal>
    );
  }
}

export default ExportModal;
